import { DroneCursor, Footer, Header, ScrollToTop, SEO } from '@/components';
import { Community } from '@/containers/home/sections/community';
import { Contact } from '@/containers/home/sections/contact';
import { CourseDetails } from '@/containers/home/sections/course-details';
import { FAQ } from '@/containers/home/sections/faq';
import { Guarantee } from '@/containers/home/sections/guarantee';
import { HeroCourse } from '@/containers/home/sections/hero-course';
import { HighlightedPaths } from '@/containers/home/sections/highlighted-paths';
import { Instructor } from '@/containers/home/sections/instructor';
import { MappingCourse } from '@/containers/home/sections/mapping-course';
import { OtherCourses } from '@/containers/home/sections/other-courses';
import { Timeline } from '@/containers/home/sections/timeline';
import { VslVideo } from '@/containers/home/sections/vsl-video';

export function Home() {
  return (
    <div className="min-h-screen bg-background text-foreground transition-colors duration-300">
      <DroneCursor />
      <SEO
        title="Curso de Piloto de Drone Agrícola de Pulverização"
        description="Formação completa em drones de pulverização agrícola. Curso de pilotagem, mapeamento aéreo 3D e manutenção com o Guri dos Drones. Do zero à atuação com segurança no agro."
        keywords="curso drone agrícola, piloto drone pulverização, mapeamento aéreo 3D, guri dos drones, drone dji agras, drone xag, agricultura de precisão, curso piloto agrícola, pulverização aérea, manutenção drone agrícola"
      />
      <Header />

      <main>
        <HeroCourse />
        <VslVideo />
        <HighlightedPaths />
        <MappingCourse />
        <CourseDetails />
        <Timeline />
        <Instructor />
        <Guarantee />
        <Community />
        <FAQ />
        <OtherCourses />
        <Contact />
      </main>

      <Footer />
      <ScrollToTop />
    </div>
  );
}
